module.exports = __webpack_public_path__ + "static/media/spotrix-black.7fdf89a3.svg";